import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'autoLabelFunction'
})
export class AutoCompleteLabelFunctionPipe implements PipeTransform {

  transform(value: any, ...args: any[]): any {
    return args[0](value);
  }

}